import { CommonAlertService } from './../../services/common-alert.service';
import { filter } from 'rxjs/operators';
import { MasterService } from './../../home/services/master.service';
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { NgForm, Form } from '@angular/forms';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';


@Component({
  selector: 'app-report-modal',
  templateUrl: './report-modal.component.html',
  styleUrls: ['./report-modal.component.scss']
})
export class ReportModalComponent implements OnInit {
  public rolesData: any;
  public editOb: any;
  public editData: any;
  public locationData: {};
  successMsg: any;
  public formData = {
    report_name : '',
    report_type : '',
  };
  public editPermission = false;
  public formShow = 'add';
  constructor(public dialogRef: MatDialogRef<ReportModalComponent>,
              public masterService: MasterService, @Inject(MAT_DIALOG_DATA) data, public commonAlertService: CommonAlertService) {
    if (data) {
      this.editOb = data;
      this.formShow = this.editOb.type;
    }
  }

  ngOnInit() {

            // @ts-ignore
    // tslint:disable-next-line:triple-equals
    if (localStorage.getItem('roleId') == 0) {
      // @ts-ignore
      // tslint:disable-next-line:max-line-length
      this.editPermission = true;
    } else {
      const roles = JSON.parse(localStorage.getItem('roles'));
      // tslint:disable-next-line:triple-equals
      if (roles['more.report.edit'] == 1) {
        this.editPermission = true;
      }
    }
    //this.masterService.getData('/user_roles/get').subscribe(res => {
      // @ts-ignore
    //  this.rolesData = res.data;
    //});
    //this.masterService.getData('/locations/get').subscribe(res => {
      // @ts-ignore
    //  this.locationData = res.data;

    //});
    if (this.editOb) {
      const id = this.editOb.id;
      // tslint:disable-next-line:variable-name
      const enc_id = this.editOb.enc_Id;
      this.masterService.getRecordById(id, enc_id, '/user_roles/getreport').subscribe(res => {
        // @ts-ignore
        this.editData = res.data;
      });
    }
  }

  submitForm(data) {
    if (this.editData) {
      const url =  '/user_roles/updatereport' ;
      // tslint:disable-next-line:variable-name no-shadowed-variable max-line-length
      const form_data = Object.assign(data, { id: this.editOb.id }, { enc_id: this.editOb.enc_id }, { token: localStorage.getItem('token')});
      this.successMsg = 'Record Updated Successfully';
      this.masterService.addEditRecord(form_data, url).subscribe(res => {
        // @ts-ignore
        if (res.success) {
          this.commonAlertService.showEdit({message: this.successMsg});
        }
      });
    } else {
      // tslint:disable-next-line:variable-name
      const form_data = Object.assign(data,  { token: localStorage.getItem('token')});
      this.successMsg = 'Record Added Successfully';
      this.masterService.addEditRecord(form_data, '/user_roles/addreport').subscribe(res => {
        // @ts-ignore
        if (res.success) {
          this.commonAlertService.showSuccessMsg({message: this.successMsg});
        }
      });
    }


    this.close();
  }

  close() {
    this.dialogRef.close();
  }

}
